/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './ContactAssignmentService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#createContactAssignmentLite
 */
export const CREATE_CONTACT_ASSIGNMENT_LITE_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_createContactAssignmentLite';
export const CREATE_CONTACT_ASSIGNMENT_LITE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CONTACT_ASSIGNMENT_LITE_MUTATION_FIELD_NAME,
  args: ['vid', 'agentId', 'agentRunId', 'automationType', 'companyAssignmentId', 'state', 'researchMeta', 'cadenceSelectionMeta', 'cadencePreparationMeta', 'cadenceApprovalMeta', 'cadenceEnrollmentMeta', 'errorMeta', 'estimatedStartTime', 'enrollSourceMeta', 'outreachUnenrollType', 'outreachUnenrolledAt', 'outreachUnenrolledByUserId', 'cadenceMeetingBookedCount', 'outreachEmailOpenCount', 'outreachEmailClickCount', 'outreachEmailReplyCount', 'outreachLastStepExecutedAt', 'outreachNextStepExpectedAt', 'outreachStepCount', 'agenticWaitType', 'outreachLanguage', 'nextAgentSuggestedCheckInTime'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createContactAssignmentLiteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#approveCadenceSelection
 */
export const APPROVE_CADENCE_SELECTION_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_approveCadenceSelection';
export const APPROVE_CADENCE_SELECTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPROVE_CADENCE_SELECTION_MUTATION_FIELD_NAME,
  args: ['id', 'cadenceEnrollment'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.approveCadenceSelectionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getContactAssignmentLite
 */
export const GET_CONTACT_ASSIGNMENT_LITE_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getContactAssignmentLite';
export const GET_CONTACT_ASSIGNMENT_LITE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTACT_ASSIGNMENT_LITE_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getContactAssignmentLiteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getContactAssignmentLitesPaged
 */
export const GET_CONTACT_ASSIGNMENT_LITES_PAGED_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getContactAssignmentLitesPaged';
export const GET_CONTACT_ASSIGNMENT_LITES_PAGED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTACT_ASSIGNMENT_LITES_PAGED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getContactAssignmentLitesPagedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getContactAssignment
 */
export const GET_CONTACT_ASSIGNMENT_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getContactAssignment';
export const GET_CONTACT_ASSIGNMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTACT_ASSIGNMENT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getContactAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getContactAssignmentV2
 */
export const GET_CONTACT_ASSIGNMENT_V2_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getContactAssignmentV2';
export const GET_CONTACT_ASSIGNMENT_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTACT_ASSIGNMENT_V2_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getContactAssignmentV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getContactAssignmentsPaged
 */
export const GET_CONTACT_ASSIGNMENTS_PAGED_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getContactAssignmentsPaged';
export const GET_CONTACT_ASSIGNMENTS_PAGED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTACT_ASSIGNMENTS_PAGED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getContactAssignmentsPagedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#resumeContactAssignments
 */
export const RESUME_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_resumeContactAssignments';
export const RESUME_CONTACT_ASSIGNMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESUME_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.resumeContactAssignmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#unenrollContactAssignment
 */
export const UNENROLL_CONTACT_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_unenrollContactAssignment';
export const UNENROLL_CONTACT_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNENROLL_CONTACT_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.unenrollContactAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#bulkUnenrollContactAssignments
 */
export const BULK_UNENROLL_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_bulkUnenrollContactAssignments';
export const BULK_UNENROLL_CONTACT_ASSIGNMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_UNENROLL_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.bulkUnenrollContactAssignmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#reenqueueContactAssignments
 */
export const REENQUEUE_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_reenqueueContactAssignments';
export const REENQUEUE_CONTACT_ASSIGNMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REENQUEUE_CONTACT_ASSIGNMENTS_MUTATION_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.reenqueueContactAssignmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getRateLimitUsage
 */
export const GET_RATE_LIMIT_USAGE_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getRateLimitUsage';
export const GET_RATE_LIMIT_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RATE_LIMIT_USAGE_QUERY_FIELD_NAME,
  args: ['limitType', 'timestamp'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getRateLimitUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#searchContactAssignmentsV2
 */
export const SEARCH_CONTACT_ASSIGNMENTS_V2_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_searchContactAssignmentsV2';
export const SEARCH_CONTACT_ASSIGNMENTS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_CONTACT_ASSIGNMENTS_V2_QUERY_FIELD_NAME,
  args: ['query', 'sorts', 'filters', 'offset', 'count', 'fileName'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.searchContactAssignmentsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getActiveAssignmentsForContact
 */
export const GET_ACTIVE_ASSIGNMENTS_FOR_CONTACT_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getActiveAssignmentsForContact';
export const GET_ACTIVE_ASSIGNMENTS_FOR_CONTACT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_ASSIGNMENTS_FOR_CONTACT_QUERY_FIELD_NAME,
  args: ['contactId'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getActiveAssignmentsForContactRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getAssociations
 */
export const GET_ASSOCIATIONS_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getAssociations';
export const GET_ASSOCIATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ASSOCIATIONS_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getAssociationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getAgentDecisionsForAssignment
 */
export const GET_AGENT_DECISIONS_FOR_ASSIGNMENT_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getAgentDecisionsForAssignment';
export const GET_AGENT_DECISIONS_FOR_ASSIGNMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_DECISIONS_FOR_ASSIGNMENT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getAgentDecisionsForAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#kickContactAssignment
 */
export const KICK_CONTACT_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_kickContactAssignment';
export const KICK_CONTACT_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: KICK_CONTACT_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['contactAssignmentId', 'userMessage'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.kickContactAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getAgentDecisionsForAssignmentV2
 */
export const GET_AGENT_DECISIONS_FOR_ASSIGNMENT_V2_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getAgentDecisionsForAssignmentV2';
export const GET_AGENT_DECISIONS_FOR_ASSIGNMENT_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_DECISIONS_FOR_ASSIGNMENT_V2_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.getAgentDecisionsForAssignmentV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#exportContactAssignments
 */
export const EXPORT_CONTACT_ASSIGNMENTS_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_exportContactAssignments';
export const EXPORT_CONTACT_ASSIGNMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: EXPORT_CONTACT_ASSIGNMENTS_QUERY_FIELD_NAME,
  args: ['query', 'sorts', 'filters', 'offset', 'count', 'fileName'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.exportContactAssignmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService#getActiveOrMostRecentAssignmentForContact
 */
export const GET_ACTIVE_OR_MOST_RECENT_ASSIGNMENT_FOR_CONTACT_QUERY_FIELD_NAME = 'com_hubspot_prospecting_agent_rpc_ContactAssignmentService_getActiveOrMostRecentAssignmentForContact';
export const GET_ACTIVE_OR_MOST_RECENT_ASSIGNMENT_FOR_CONTACT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_OR_MOST_RECENT_ASSIGNMENT_FOR_CONTACT_QUERY_FIELD_NAME,
  args: ['contactId'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.getActiveOrMostRecentAssignmentForContactRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});